import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { filterOptionsAction } from '../store/actions';
import './radio.css';

const StyledDivContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr
  grid-template-rows: repeat(5, 3rem);
  justify-content: center;
`;

const StyledDivSubContainer = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: 20rem;
  grid-auto-rows: 1fr;
`;

const StyledDivOptionContianer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(6, 2rem 1rm);
`;

const StyledDivOptionContianerInner = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Line = styled.hr`
  border: 0;
  width: 100%;
  border-top: 1px solid #e3e3e3;
`;

const FilterSearchButton = styled.button`
  top: 2rem;
  position: relative;
  height: 3.2rem;
  width: 3.2rem;
  border-radius: 5rem;
  background-color: red;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  justify-self: center;
  border: none;
  transition: all 0.5s;
  &::after {
    content: 'X';
    color: white;
    font-size: 1rem;
  }
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.5;
  }
  }
`;

const BodyText = styled.p`
  font-family: 'Open Sans', sans-serif;
  color: #939598;
  font-weight: 700;
  font-size: 1rem;
  @media (max-width: 700px) {
    font-size: 2rem;
  }
`;

class SearchFilter extends Component {
  constructor(props) {
    super(props);
    this.state = { radio: 'sure', filterOptions: 'track' };
  }

  _handleFilterChange = e => {
    console.log(e);
    this.setState({ filterOptions: e.target.value });
  };

  render() {
    const { closeModal } = this.props;
    console.log(this.props.music);
    return (
      <StyledDivContainer>
        <StyledDivSubContainer>
          <BodyText>Filter your search using</BodyText>
          <StyledDivOptionContianer>
            <StyledDivOptionContianerInner>
              <BodyText>Artist</BodyText>
              <label className="container">
                <input
                  type="radio"
                  checked={this.props.music.filterOptions === 'artist'}
                  name="radio"
                  value="artist"
                  onChange={this.props.filterOptionsAction}
                />
                <span className="checkmark" />
              </label>
            </StyledDivOptionContianerInner>
            <Line />
            <StyledDivOptionContianerInner>
              <BodyText>Track</BodyText>
              <label className="container">
                <input
                  type="radio"
                  checked={this.props.music.filterOptions === 'track'}
                  name="radio"
                  value="track"
                  onChange={this.props.filterOptionsAction}
                />
                <span className="checkmark" />
              </label>
            </StyledDivOptionContianerInner>
            <Line />
            <StyledDivOptionContianerInner>
              <BodyText>Album</BodyText>
              <label className="container">
                <input
                  type="radio"
                  checked={this.props.music.filterOptions === 'album'}
                  name="radio"
                  value="album"
                  onChange={this.props.filterOptionsAction}
                />
                <span className="checkmark" />
              </label>
            </StyledDivOptionContianerInner>
            <Line />
          </StyledDivOptionContianer>
          <FilterSearchButton type="button" onClick={closeModal} />
        </StyledDivSubContainer>
      </StyledDivContainer>
    );
  }
}

const mapStateToProps = state => ({
  music: state.music,
});

export default connect(
  mapStateToProps,
  { filterOptionsAction }
)(SearchFilter);



// WEBPACK FOOTER //
// ./src/components/SearchFilter.js